// The server stamps every turn clock, deadline and chat/emoji time with ITS
// wall clock. Comparing those with this device's `Date.now()` turns device
// clock drift into timers that stall or jump, so compare with `serverNow()`
// instead: the device clock corrected by an offset measured over the room
// socket (`clock_sync` probes, see `attachBaseHandlers`).

/** Server clock minus device clock, in ms. */
let offsetMs = 0;
/** Round trip of the probe `offsetMs` came from — the tightest one wins. */
let bestRoundTripMs = Infinity;

/** Now, on the server's clock, as best this device can tell. */
export function serverNow(): number {
  return Date.now() + offsetMs;
}

/** A new room connection starts a fresh measurement: its first probe reply
 * replaces the old offset (kept until then, so timers don't jump). */
export function resetServerClock(): void {
  bestRoundTripMs = Infinity;
}

/** Fold in one probe reply: the server read `serverNowMs` for a probe this
 * device sent at `sentAt`. Assuming even legs, it read its clock at the round
 * trip's midpoint. The tightest round trip leaves an uneven leg the least
 * room to skew the estimate, so only a tighter probe replaces the offset. */
export function recordServerClockSample(
  sentAt: number,
  serverNowMs: number,
): void {
  const roundTrip = Date.now() - sentAt;
  if (roundTrip < 0 || roundTrip >= bestRoundTripMs) return;
  bestRoundTripMs = roundTrip;
  offsetMs = serverNowMs - (sentAt + roundTrip / 2);
}
